module.exports = __webpack_public_path__ + "img/dy.6d6202c8.jpg";